import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const SizeSelector = ({ currentSize, setCurrentSize, availableSizes }) => {
    return (
        <Box display="flex" justifyContent="center" my={2}>
            <FormControl sx={{ minWidth: 200 }}>
                <InputLabel>リサイズするサイズ</InputLabel>
                <Select 
                    value={currentSize} 
                    onChange={(e) => setCurrentSize(e.target.value)}
                >
                    {availableSizes.map((size) => (
                        <MenuItem key={size} value={size}>
                            {size} x {size}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default SizeSelector;
